export const isFullStatic = false
export const staticPath = "/home/hitaxi/domains/app.hitaxivipairport.com/front-end/.nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"